import { createModel } from 'xstate/lib/model';

import { CompanyContextType } from 'common/hooks/useCompanyContext/types';
import baseEvents from 'features/Bento/libs/machines/config/baseEvents';

import { BusinessInfoModuleDataQuery } from '../graphql/queries/businessInfoModuleData.gql';
import { IdentityInfoPayload } from '../pages/IdentityInfoEdit/IdentityInfoEdit';
import { LegalInfoPayload } from '../pages/LegalInfoEdit/LegalInfoEdit';
import { ExtendedBusinessForm, ExternalCompanyProfileInfo } from '../types';

type BusinessInfoModuleData = {
  businessInfoData: BusinessInfoModuleDataQuery;
  companyContext: CompanyContextType;
  existingCompanyProfileId?: string;
};

export interface CompanyProfileInputState {
  activityDetails: string | null;
  activityType: string;
  city: string;
  country: string;
  inseeLegalFormCode: string | null;
  isMicro: boolean | null;
  isExternal: boolean;
  legalAnnualTurnOver: string | null;
  legalForm: string;
  legalName: string;
  legalNumberOfEmployeeRange: string | null;
  legalRegistrationNumber: string;
  legalShareCapital: number | null;
  registrationDate: string | null;
  street: string;
  streetAddition: string;
  tradeName: string;
  zip: string;
}

export const initialCompanyProfile: CompanyProfileInputState = {
  activityDetails: '',
  activityType: '',
  city: '',
  country: 'FR',
  inseeLegalFormCode: null,
  isExternal: false, // set to true when the user selects a company from the search page
  isMicro: null,
  legalAnnualTurnOver: null,
  legalForm: '',
  legalName: '',
  legalNumberOfEmployeeRange: null,
  legalRegistrationNumber: '',
  legalShareCapital: null,
  registrationDate: null,
  street: '',
  streetAddition: '',
  tradeName: '',
  zip: '',
};

const context = {
  companyProfile: initialCompanyProfile,
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => BusinessInfoModuleData,
};

export type Context = typeof context;

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,

      EDIT_IDENTITY_INFO: () => ({}),
      EDIT_LEGAL_INFO: () => ({}),
      'error.platform.submitCompanyInfo': (data: Error) => ({ data }),
      GO_CAPITAL_DEPOSIT: () => ({}),
      GO_INFO_EDIT: () => ({}),
      RESTART_ONBOARDING: () => ({}),
      RESUME_ONBOARDING: () => ({}),
      SKIP_EXTERNAL_COMPANY: () => ({}),
      SUBMIT_APE_DETAILS: (data: string) => ({ data }),
      SUBMIT_BUSINESS_FORM: (data: ExtendedBusinessForm) => ({ data }),
      SUBMIT_EXTERNAL_COMPANY: (data: ExternalCompanyProfileInfo) => ({
        data,
      }),
      SUBMIT_IDENTITY_INFO: (data: IdentityInfoPayload) => ({ data }),
      SUBMIT_IS_MICRO: (data: boolean) => ({ data }),
      SUBMIT_LEGAL_INFO: (data: LegalInfoPayload) => ({ data }),
      VALIDATE_INFORMATION: () => ({}),
    },
  },
);

export type Model = typeof model;

export default model;
